/**
 * Display Panel Service
 * API calls for TV display panel
 */

import apiClient from './apiClient';
import { DisplayPanelData } from '../types/display';

/**
 * Display service for fetching queue display data
 * Uses public endpoint (no authentication required)
 */
class DisplayService {
  private readonly baseUrl = '/appointments';

  /**
   * Get display panel data for a clinic
   * @param clinicId - Clinic ID
   * @param date - Optional date in YYYY-MM-DD format (defaults to today)
   * @returns Display panel data
   */
  async getDisplayData(clinicId: number, date?: string): Promise<DisplayPanelData> {
    const params = new URLSearchParams();
    params.append('clinicId', clinicId.toString());
    if (date) {
      params.append('date', date);
    }

    const response = await apiClient.get<DisplayPanelData>(
      `${this.baseUrl}/display?${params.toString()}`
    );

    if (!response.data) {
      throw new Error('Resposta invalida do servidor');
    }

    return response.data;
  }
}

export const displayService = new DisplayService();
export default displayService;
